export enum AnyHierarchyLevel {
	CUSTOMER = 'customer',
	CUSTOMER_GROUP = 'customer_group',

	MARKET = 'market',
	SALES_CHANNEL = 'sales_channel',
	SALES_FORCE = 'sales_force',
	SALES_ZONE = 'sales_zone',
	SELLER = 'seller',

	PRODUCT = 'product',
	FAMILY = 'family',
	SUBFAMILY = 'subfamily',
	MODEL = 'model',
}

export type HierarchyType = 'product' | 'commercial' | 'customer';
